import { render, staticRenderFns } from "./TeachingPhotos.vue?vue&type=template&id=2efe796c&scoped=true&"
import script from "./TeachingPhotos.vue?vue&type=script&lang=js&"
export * from "./TeachingPhotos.vue?vue&type=script&lang=js&"
import style0 from "./TeachingPhotos.vue?vue&type=style&index=0&id=2efe796c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe796c",
  null
  
)

export default component.exports